export default function Navbar() {
    return (
        <section>
            <div class="w-screen h-14 bg-ms-dark">
            </div>
            <div class="w-screen h-2 bg-purple-heart" />
        </section>
    );
}